import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { formatPrice } from '../api';

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.order;

  return (
    <main className="max-w-3xl mx-auto px-6 py-24 text-center">
      <CheckCircle2 className="w-14 h-14 text-[#C6410E] mx-auto mb-6" />
      <p className="text-[11px] tracking-widest-plus uppercase text-[#C6410E] mb-4">Order confirmed</p>
      <h1 className="font-serif-display text-5xl md:text-6xl mb-6">Thank you.</h1>
      <p className="text-[#1a1a1a]/70 mb-10 max-w-xl mx-auto">
        Your order has been received and our workshop has been notified. A confirmation is on its way to your inbox, and we will write again as soon as it ships.
      </p>
      {order && (
        <div className="border border-black/10 p-8 text-left inline-block min-w-[300px]">
          <p className="text-[11px] tracking-widest-plus uppercase text-[#1a1a1a]/60 mb-1">Order number</p>
          <p className="font-serif-display text-2xl mb-4">{order.id}</p>
          <p className="text-sm">Total <span className="font-medium">{formatPrice(order.total)}</span> · {order.payment_status === 'paid' ? 'Paid online' : 'Cash on Delivery'}</p>
        </div>
      )}
      <div className="mt-10 flex gap-4 justify-center flex-wrap">
        <Link to="/shop" className="btn-primary">Continue shopping</Link>
        <Link to="/track" state={order ? { order_id: order.id, email: order.shipping?.email } : undefined} data-testid="success-track-link" className="btn-ghost">Track this order</Link>
      </div>
    </main>
  );
}
